import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AEssenciaAbHft() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="48067" id="nossa-história-e-missão" ref={ref} className="bg-background text-[rgb(48,213,152)] relative w-full overflow-hidden">
      <div className="grid lg:grid-cols-2 min-h-[85vh]">
        {}
        <div className={`relative h-full min-h-[500px] w-full overflow-hidden transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10"}`}>
           {}
          <img src="https://able-narwhal.10web.cloud/wp-content/uploads/2026/04/ChatGPT-Image-16-de-abr.-de-2026-11_56_17.png" alt="Interior sofisticado da KG Viagens em Florianópolis" className="absolute inset-0 h-full w-full object-cover" />
        </div>

        {}
        <div className="relative flex flex-col justify-center px-8 py-20 md:px-16 lg:px-24 xl:px-32">
          <div className={`space-y-8 transition-all duration-1000 delay-300 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            {}
            <div className="h-px w-24 bg-secondary" />

            {}
            <div className="space-y-4 !text-[rgba(27,164,172,1)]">
              <span className="block font-default text-xs font-medium tracking-[0.2em] uppercase !text-[rgba(27,164,172,1)]">
                Sediada em Florianópolis
              </span>
              <h2 className="font-default text-4xl font-medium leading-[1.1] !text-[rgba(27,164,172,1)] md:text-5xl lg:text-6xl">
                Nossa História <br />
                <span className="italic !text-[rgba(27,164,172,1)]">& Missão</span>
              </h2>
            </div>

            {}
            <div className="space-y-6 text-muted-foreground font-default text-lg leading-relaxed tracking-wide font-light">
              <p>Viajar vai muito além de conhecer novos destinos.<div>É sobre viver histórias, despertar emoções e se permitir transformar.</div><div><br /></div><div>A KG VIAGENS nasceu com um propósito claro: proporcionar experiências de viagem cuidadosamente planejadas para pessoas que valorizam conforto, segurança e significado em cada detalhe.</div><div><br /></div><div>Sabemos que o seu tempo é valioso — e que viajar não pode ser motivo de preocupação. Por isso, cuidamos de absolutamente tudo: do primeiro contato até o seu retorno para casa. Cada roteiro é pensado com sensibilidade, organização e um olhar atento às suas expectativas, para que você simplesmente viva o melhor da viagem.</div><div><br /></div><div>Somos especialistas em experiências culturais e viagens em grupo, reunindo pessoas com perfis semelhantes, que buscam mais do que turismo: buscam conexão, tranquilidade e momentos que realmente façam sentido.</div><div><br /></div><div>Aqui, você nunca está sozinho(a).</div><div>Nossa equipe acompanha cada etapa, oferecendo suporte próximo, humano e profissional — antes, durante e depois da sua viagem.</div><div><br /></div><div className="!text-[rgba(27,164,172,1)]">KG VIAGENS</div><div>Sua jornada começa com confiança, e termina com memórias que ficam para sempre.</div></p>
              
            </div>

            {}
            <div className="pt-4">
              <Button asChild variant="link" className="text-foreground hover:text-secondary p-0 h-auto text-base font-medium tracking-widest uppercase group">
                
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}